import { Outlet, useParams, useLocation, Navigate } from "react-router-dom";
import { useSectionNavLinks } from "../_utils";
import AppLayout from "@/layouts/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

export default function SectionIdLayout() {
  const { sectionId } = useParams();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { pathname, search } = useLocation();
  const navLinks = useSectionNavLinks(sectionId);
  const isSettings = pathname.endsWith("/settings");
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  if (!flagsLoaded) {
    return null;
  }

  if (flags["backoffice-section-people"] === true && sectionId) {
    const settingsSuffix = isSettings ? "/settings" : "";
    return <Navigate to={`/sections/${sectionId}/people/change-requests${settingsSuffix}${search}`} replace />;
  }

  if (!sectionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Section ID not found" />
      </div>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && !isSettings && (
        <Breadcrumb
          compactOnly
          compactTitle="Change Requests"
          backLink={{ to: "/sections/:sectionId", params: { sectionId: sectionId! } }}
        />
      )}
      <Outlet />
    </AppLayout>
  );
}
